import { type MapSettingsDataAction } from '../../data/mapSettingsData.action';
import {
  clearDirectionsRoutes, removeRouteFromDirections,
} from '../../directions/mapSettingsDirections.actionCreators';
import { type MapSettingsHeatmapsAction } from '../../heatmaps/mapSettingsHeatmaps.action';
import type { MapSettingsPlacesAction } from '../../places/mapSettingsPlaces.action';
import { mapSettingsPlacesRemoveSearch } from '../../places/mapSettingsPlaces.actionCreators';
import { type VisibilityAction } from './visibility.action';
import {
  toolStateHidePlaceSearch,
  toolStateHideRoute, toolStateShowPlaceSearch, toolStateShowRoute,
} from './visibility.actionCreators';
import {
  MAP_SETTINGS_VISIBILITY_HIDE_HEATMAP,
  MAP_SETTINGS_VISIBILITY_HIDE_PROXIMITY,
  MAP_SETTINGS_VISIBILITY_SHOW_HEATMAP,
  MAP_SETTINGS_VISIBILITY_SHOW_PROXIMITY,
} from './visibility.actionTypes';
import { type VisibilityState } from './visibility.state';

export const mapSettingsVisibilityInitialState: VisibilityState = {
  hiddenProximityIds: [],
  hiddenHeatmapIds: [],
  hiddenRouteIds: [],
  hiddenPlaceSearchIds: [],
};

export const visibilityReducer = (
  state = mapSettingsVisibilityInitialState,
  action: VisibilityAction | MapSettingsHeatmapsAction | MapSettingsDataAction | MapSettingsPlacesAction
): VisibilityState => {

  // Directions
  if (toolStateShowRoute.match(action) || removeRouteFromDirections.match(action)) {
    return {
      ...state,
      hiddenRouteIds: state.hiddenRouteIds.filter(id => id !== action.payload.routeId),
    };
  }
  if (toolStateHideRoute.match(action)) {
    return {
      ...state,
      hiddenRouteIds: [...state.hiddenRouteIds, action.payload.routeId],
    };
  }
  if (clearDirectionsRoutes.match(action)) {
    return {
      ...state,
      hiddenRouteIds: [],
    };
  }

  // Place Searches
  if (toolStateShowPlaceSearch.match(action)) {
    return {
      ...state,
      hiddenPlaceSearchIds: state.hiddenPlaceSearchIds.filter(id => id !== action.payload.placeSearchId),
    };
  }
  if (mapSettingsPlacesRemoveSearch.match(action)) {
    return {
      ...state,
      hiddenPlaceSearchIds: state.hiddenPlaceSearchIds.filter(id => id !== action.payload.search.id),
    };
  }
  if (toolStateHidePlaceSearch.match(action)) {
    return {
      ...state,
      hiddenPlaceSearchIds: [...state.hiddenPlaceSearchIds, action.payload.placeSearchId],
    };
  }

  switch (action.type) {

    // Proximities
    case MAP_SETTINGS_VISIBILITY_SHOW_PROXIMITY:
      return {
        ...state,
        hiddenProximityIds: state.hiddenProximityIds.filter(id => id !== action.payload.proximityId),
      };

    case MAP_SETTINGS_VISIBILITY_HIDE_PROXIMITY:
      return {
        ...state,
        hiddenProximityIds: [...state.hiddenProximityIds, action.payload.proximityId],
      };

    // Heatmaps
    case MAP_SETTINGS_VISIBILITY_SHOW_HEATMAP:
      return {
        ...state,
        hiddenHeatmapIds: state.hiddenHeatmapIds.filter(id => id !== action.payload.heatMapId),
      };

    case MAP_SETTINGS_VISIBILITY_HIDE_HEATMAP:
      return {
        ...state,
        hiddenHeatmapIds: [...state.hiddenHeatmapIds, action.payload.heatMapId],
      };

    default:
      return state;
  }
};
